import React from "react";
import {
  SpacesContainer,
  SpacesWrapper,
  SpacesTitle,
  SpacesOverviewContainer,
} from "./styles";
import { SpaceCard, SpaceList } from "@caelor/ui";
import { useOpticsStore } from "../../../../../../stores/use-optics-store";
import { useSpacesStore } from "../../../../../../stores/use-space-store";
import { MACRO_KEY } from "../../../../../defaults";
import { OVERVIEW_DUMMY_DATA } from "./data";
import { buildTemplate, SPACE_TEMPLATES } from "./spaces-templates";

const CardRender = ({ borderRadius }) => (
  <div style={{ display: "flex", flexFlow: "row", gap: 8 }}>
    <div style={{ width: 170 }}>
      <SpaceCard
        name="Global Marketing Campaigns"
        description="Your go-to hub for planning and launching marketing campaigns."
        authorName="Lena Morales"
        authorUrl="https://www.linkedin.com/in/angelicalorens/"
        spaceIcon="/img/spaceIcon.svg"
        borderRadius={borderRadius}
        accentColor={{
          light: "#1D7AFC",
          dark: "#1D7AFC",
        }}
        isTemplate
      />
    </div>
    <div style={{ width: 170 }}>
      <SpaceCard
        name="Learning and Development Hub"
        description="Centralize onboarding, training resources, and upskilling programs "
        authorName="David Koenig"
        authorUrl="https://www.linkedin.com/in/angelicalorens/"
        spaceIcon="/img/spaceIcon.svg"
        borderRadius={borderRadius}
        accentColor={{
          light: "#1D7AFC",
          dark: "#1D7AFC",
        }}
        isTemplate
      />
    </div>
  </div>
);

const ListRender = ({ borderRadius }) => (
  <div style={{ display: "flex", flexFlow: "column", gap: 8 }}>
    <div style={{ width: 475 }}>
      <SpaceList
        name="IT Help & Knowledge"
        description="Resources and specs for the design team."
        authorName="Rina Sharma"
        authorUrl="https://www.linkedin.com/in/angelicalorens/"
        spaceIcon="/img/spaceIcon.svg"
        borderRadius={borderRadius}
        accentColor={{
          light: "#1D7AFC",
          dark: "#1D7AFC",
        }}
        isTemplate
      />
    </div>
    <div style={{ width: 475 }}>
      <SpaceList
        name="Product Launch Central"
        description="Resources and specs for the design team."
        authorName="Marcus Li"
        authorUrl="https://www.linkedin.com/in/angelicalorens/"
        spaceIcon="/img/spaceIcon.svg"
        borderRadius={borderRadius}
        accentColor={{
          light: "#1D7AFC",
          dark: "#1D7AFC",
        }}
        isTemplate
      />
    </div>
    <div style={{ width: 475 }}>
      <SpaceList
        name="Internal Comms"
        description="Resources and specs for the design team."
        authorName="David Koenig"
        authorUrl="https://www.linkedin.com/in/angelicalorens/"
        spaceIcon="/img/spaceIcon.svg"
        borderRadius={borderRadius}
        accentColor={{
          light: "#1D7AFC",
          dark: "#1D7AFC",
        }}
        isTemplate
      />
    </div>
  </div>
);

const VIEWS = {
  card: { label: "Card", View: CardRender },
  list: { label: "List", View: ListRender },
};

export const OverviewTemplates = () => {
  const { setData } = useSpacesStore((state) => ({
    setData: state.setData,
  }));
  const { setMacro, setDrawers, styleguideSetup } = useOpticsStore((state) => ({
    setMacro: state.setMacro,
    setDrawers: state.setDrawers,
    styleguideSetup: state.styleguideSetup,
  }));

  const borderRadius = styleguideSetup?.cornerRadius || 3;

  return (
    <SpacesOverviewContainer
      onClick={() => {
        setMacro({ key: MACRO_KEY.SPACES });
        setData({ ...buildTemplate("card", borderRadius) });
        setDrawers({ templates: false, settings: true });
      }}
    >
      {OVERVIEW_DUMMY_DATA.map((space) => (
        <SpaceCard
          name={space.name}
          description={space.description}
          authorName={space.authorName}
          authorUrl="https://www.linkedin.com/in/angelicalorens/"
          spaceIcon={space.spaceIcon}
          borderRadius={borderRadius}
          accentColor={{
            light: "#1D7AFC",
            dark: "#1D7AFC",
          }}
          coverPictureCallback={() =>
            Promise.resolve(
              "https://caelor-apps.web.app/images/fields/month-week.svg"
            )
          }
        />
      ))}
    </SpacesOverviewContainer>
  );
};

const SpacesTemplates = () => {
  const { data, setData } = useSpacesStore((state) => ({
    data: state.data,
    setData: state.setData,
  }));
  const { setDrawers, styleguideSetup } = useOpticsStore((state) => ({
    setDrawers: state.setDrawers,
    styleguideSetup: state.styleguideSetup,
  }));

  const borderRadius = styleguideSetup?.cornerRadius || 3;

  const buildData = (template, value) => {
    if (Object.keys(data || {}).length) {
      return {
        ...data,
        config: {
          ...data.config,
          variant: value.variant,
        },
      };
    }

    const newData = {
      ...template,
      config: { ...template.config, ...value },
    };
    return newData;
  };

  return (
    <SpacesContainer>
      {SPACE_TEMPLATES.map((template) => {
        const { label, View } = VIEWS[template.config.variant];
        return (
          <SpacesWrapper
            key={template.id}
            onClick={() => {
              setData({
                ...buildData(template, {
                  cardBorderRadius: borderRadius,
                  variant: template.config.variant,
                }),
              });
              setDrawers({ templates: false, settings: true });
            }}
          >
            <SpacesTitle>{label}</SpacesTitle>
            <View borderRadius={borderRadius} />
          </SpacesWrapper>
        );
      })}
    </SpacesContainer>
  );
};

export default SpacesTemplates;
